// Mapper for employee export operations

export interface EmployeeExportFilters {
  companyId: number;
  searchText?: string;
  statusFilter?: 'ALL' | 'V' | 'NV';
  contractStatusFilter?: 'ACTIVE' | 'INACTIVE' | 'ALL';
}

/**
 * Parameters for employee export API
 */
export interface EmployeeExportParams {
  companyId: number;
  searchText?: string;
  employeeStatus?: string;
  contractStatusFilter?: string;
}

/**
 * Maps internal filter format to backend API format
 * Maps statusFilter: ALL -> T, V -> V, NV -> NV
 */
export function mapEmployeeExportFilters(
  filters: EmployeeExportFilters,
): EmployeeExportParams {
  return {
    companyId: filters.companyId,
    searchText: filters.searchText,
    employeeStatus: filters.statusFilter === 'ALL' ? 'T' : filters.statusFilter,
    contractStatusFilter: filters.contractStatusFilter ?? 'ALL',
  };
}
